
import {Col} from "react-bootstrap";

function DataPage() {
    return (
        <Col lg={12} className="px-0">
            <p >
                The SPARQL endpoint is at <a href={"https://molor.eu/sparql"} target={"_blank"}  rel="noreferrer">molor.eu/sparql</a>.
                For the GitHub repository, which includes the MOLOR Lemma Bank .ttl file, please refer to <a href={"https://github.com/CIRCSE/Molor"} target={"_blank"}  rel="noreferrer">https://github.com/CIRCSE/Molor</a>.
            </p>

        </Col>
    );
}

export default DataPage;

